import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import logo from "../assets/logo.png";

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer-container">
      <div className="footer-grid">
        <div>
          <Link to="/" className="base-logo-link">
            <img src={logo} className="h-36" alt="Logo" />
            {/* <span className="base-logo-text">Ordine delle Lame Scaligere</span> */}
          </Link>
        </div>
        {/* <div className="footer-top"> */}

        <div>
          <div className="footer-column-title">Navigazione</div>
          <ul className="footer-list">
            <li>
              <Link to="/corsi" className="base-logo-link">
                Scherma Storica
              </Link>
            </li>
            <li className="">
              <Link to="/istruttori" className="base-logo-link">
                Istruttori
              </Link>
            </li>
            <li>
              <Link to="/tornei" className="base-logo-link">
                Tornei
              </Link>
            </li>
            <li>
              <Link to="/medagliere" className="base-logo-link">
                Medagliere
              </Link>
            </li>
            <li>
              <Link to="/rievocazione" className="base-logo-link">
                Rievocazione
              </Link>
            </li>
            <li>
              <Link to="/gallery" className="base-logo-link">
                Gallery
              </Link>
            </li>
            <li>
              <Link to="/contatti" className="base-logo-link">
                Contatti e FAQ
              </Link>
            </li>
          </ul>
        </div>

        <div className="">
          <div className="footer-column-title">Dove siamo</div>
          {/* <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-2"></div> */}
          <div>
            <h2 className="footer-location-title">Sede di Verona (Corsi)</h2>
            <ul className="footer-list">
              <li className="footer-list-item">
                Palestra scuola Primaria "ai Ciliegi" Via Bisenzio, 11 - Verona
              </li>
            </ul>
          </div>
          <div>
            <h2 className="footer-location-title">Sede di Salionze (Corsi)</h2>
            <ul className="footer-list">
              <li className="footer-list-item">
                Palestra di Salionze Via del Garda, 34 - Salionze (Valeggio S/M)
              </li>
            </ul>
          </div>
          <div>
            <h2 className="footer-location-title">{t("footer.sede")}</h2>
            <ul className="footer-list">
              <li className="footer-list-item">
                Via Vigasio 73 - 37135 Verona
              </li>
              {/* <li className="footer-list-item">CF: 93122220234</li>
              <li className="footer-list-item">
                <a href="mailto:ordinedellelamescaligere@gmail.com">
                  ordinedellelamescaligere@gmail.com
                </a>
              </li> */}
            </ul>
          </div>
        </div>
        <div>
          <h2 className="footer-column-title">{t("footer.info")}</h2>
          <ul className="footer-list">
            <li className="footer-list-item">
              <Link to="/privacy-policy" className="footer-link">
                Privacy policy
              </Link>
            </li>
            <li className="footer-list-item">
              <Link to="/cookies" className="footer-link">
                Cookies
              </Link>
            </li>
          </ul>
        </div>
        {/* </div> */}
      </div>
      <hr className="footer-hr" />
      <div className="footer-bottom">
        <span className="footer-bottom-text">
          Made by Alessandro Gomma, based on{" "}
          <Link
            to="https://github.com/themesberg/tailwind-landing-page"
            className="footer-link"
          >
            Tailwind CSS Landing Page
          </Link>
        </span>

        <div className="footer-social">
          <Link
            to="https://www.instagram.com/ordinedellelamescaligere"
            className="footer-social-link"
          >
            <i className="fab fa-instagram fa-lg"></i>
          </Link>
          <Link
            to="https://www.facebook.com/ordinedellelamescaligere"
            className="footer-social-link"
          >
            <i className="fab fa-facebook fa-lg"></i>
          </Link>
        </div>
      </div>
      <div className="footer-bottom">
        <span className="footer-bottom-text">
          I contenuti presenti su questo sito, inclusi testi e immagini, sono
          originali e realizzati senza l'utilizzo di sistemi di intelligenza
          artificiale generativa.
        </span>
      </div>
    </footer>
  );
}

export default Footer;
